// extracted by mini-css-extract-plugin
export default {"main":"ProcessPayment_main__mJBxs","button":"ProcessPayment_button__Ym14i"};